<template>
<main class="bg-main lesson-quiz">
  <contenthead :section="sectionData" :lesson="lessonData" :contentsData="contentsData"></contenthead>
  <div class="category_title">{{ contentOrder }}. <span class="font-jp">{{ quizData.title }}</span></div>
  <section class="container">
  
    <lessonquestion v-if="quizData.questions && step" :quizData="quizData" :questions="quizData.questions" :step="step" @finquiz="finQuiz" @passedquiz="passedQuiz" @scoreresult="scoreResult"></lessonquestion>
    <div class="row pd-lr-20" v-if="fin_quiz">
        <button type="button" class="button button-primary next" @click.prevent="nextStep">{{ $t('common.button.next') }}</button>
        <button type="button" class="button undo" :class="(score_result && score_result=='failure') ? 'button-primary' : 'button-default'" @click.prevent="restartQuiz">{{ $t('lesson.question.button.over') }}</button>
        <button type="button" class="button button-default back" @click="goBack">{{ $t('lesson.exam.button.to_session') }}</button>
      </div>
    </div>
    <div class="row pd-lr-20" v-if="debug">
      <!-- 開発用 -->
      <button class="button disabled kaihatsu" @click.prevent="nextStepDev">スキップ（開発用）</button>
    </div>
  </section>

</main>
</template>

<script>
import {api, appEnv} from './../../config';
import learningLog from '../../mixins/learning-log';
import status from '../../mixins/status';
import {mapState} from 'vuex'


import componentContentHead from '../shared/ContentHead.vue';
import LessonQuestion from './LessonQuestion.vue'

export default {
  name: 'LessonQuiz',
  mixins: [
    learningLog,
    status
  ],
  components: {
    'contenthead': componentContentHead,
    'lessonquestion': LessonQuestion,
  },
  data(){
    return{
      step: 'moviequiz',
      stepSub: 'quiz',
      lessonId: null,
      contentOrder: null,
      fin_quiz: false,
      passed_quiz: false,
      score_result: null,
      contents_data: {}
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth
    }),
    sectionData() {
      return this.$store.getters.section_data;
    },
    lessonData() {
      return this.$store.getters.lesson_data;
    },
    contentsData() {
      return this.contents_data;
    },
    quizData() {
      return (this.$store.getters.lesson_content.moviequiz && this.$store.getters.lesson_content.moviequiz.content && this.contentOrder in this.$store.getters.lesson_content.moviequiz.content) ? this.$store.getters.lesson_content.moviequiz.content[this.contentOrder] : { movie: {}, questions: {}}
    },
    debug() {
      return (appEnv !== 'production')
    }
  },
  beforeRouteUpdate (to, from, next) {
    if(to.params.lesson_id != from.params.lesson_id || to.params.content_order != from.params.content_order) {
      
      this.contentOrder = to.params['content_order']
      this.lessonId = to.params['lesson_id']
      
      next();
      this.$router.go();
    }
  },
  
  created() {
    this.contentOrder = this.$route.params['content_order']
    this.lessonId = this.$route.params['lesson_id']
    
      
    axios.get(api.contents, {
      params: {
        section_id: this.$store.getters.section_data.section_id,
        lesson_id: this.$store.getters.lesson_data.lesson_id,
        lesson_type: this.$store.getters.lesson_data.lesson_type
      }
    })
    .then((resp) => {
      this.contents_data = resp.data
    })
  },
  mounted() {
    if(appEnv !== 'local') {
      const TypeSquareJS = window.TypeSquareJS;
      TypeSquareJS.loadFont && TypeSquareJS.loadFont();
    }
  },
  methods: {
    finQuiz() {
      this.fin_quiz = true
    },
    passedQuiz() {
      this.passed_quiz = true
    },
    scoreResult(result) {
      this.score_result = result
    },
    nextStep() {
      
      if (this.$store.getters.lesson_content[this.step].status != 'completed' || this.quizData.status_quiz != 'completed') {
        this.statusContent('completed', this.step, { content_data_type: 'quiz', content_data_order: this.contentOrder});
      }
      this.learningTempLog();
      this.learningLog();
      
      let contentLength = Object.keys(this.$store.getters.lesson_content.moviequiz.content)
      if(parseInt(this.contentOrder) < contentLength.length ) {
        let nextContentOrder = parseInt(this.contentOrder) + 1;
        this.$router.push({ name: 'lesson.movie', params: { lesson_id: this.lessonId, content_order: nextContentOrder }})
      } else {
        this.$router.push({ name: 'lesson.review', params: { lesson_id: this.lessonId, content_order: 1 }})
      }
    },
    nextStepDev() {
      let contentData = this.$store.getters.lesson_content.moviequiz.content[this.contentOrder]
      
      if (this.$store.getters.lesson_content[this.step].status != 'completed' || contentData.status_quiz != 'completed') {
        this.statusContent('completed', this.step, { content_data_type: 'quiz', content_data_order: this.contentOrder});
      }
      this.learningTempLog();
      
      this.$router.push({ name: 'lesson.review', params: { lesson_id: this.lessonId, content_order: 1 }})
    },

    restartQuiz(){
      this.$router.go()
    },
    
    goBack() {
      this.$router.push({name: 'lesson.category', params: { category: this.$store.getters.section_data.section } });
    }
  }
}
</script>
<style>
.kaihatsu {
  margin: 20px 0;
}

</style>